import React, { useMemo, useState } from 'react';
import FeedBackViewModal from './FeedBackViewModal';
import { usePatchReadMutation } from 'utils/rest/feedback/readFeedback';

const FeedBackMessage = ({ data }) => {
  const [open, setOpen] = useState(false);

  const { mutate: markAsRead } = usePatchReadMutation();

  const feedbackData = useMemo(() => {
    const splitData = data.feedback.split('/n/n');
    return splitData
      .map(el => {
        return {
          question: el.split('/n')[0],
          answer: el.split('/n')[1]
        };
      })
      .filter(
        el => el.answer !== '  ' && el.answer !== ' ' && el.answer !== undefined
      );
  }, [data.feedback]);

  const handleOpenFeedback = () => {
    const body = {
      readYN: 1
    };

    setOpen(true);

    if (!readYN) markAsRead({ input: body, id: data.id });
  };

  return (
    <>
      <div className="hover cursor-pointer" onClick={handleOpenFeedback}>
        Click here to view Feedback
      </div>
      {open && (
        <FeedBackViewModal
          show={open}
          close={() => setOpen(false)}
          data={feedbackData}
        />
      )}
    </>
  );
};

export default FeedBackMessage;
